export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      gallery: "Galería",
      locations: "Sedes",
      reviews: "Opiniones",
      contact: "Contacto",
      reserve: "Reservar",
    },
    hero: {
      tagline: "Bodegón porteño · desde el corazón de Buenos Aires",
      title: "BODEGÓN NÚÑEZ",
      subtitle: "— EL MÁS GRANDE —",
      description:
        "Milanesas gigantes, porciones para compartir y el sabor auténtico de la cocina porteña.",
      cta: "Reservar por WhatsApp",
      ctaSecondary: "Conocé las sedes",
      stat1: "9.000+",
      stat1Label: "Opiniones de Google",
      stat2: "4.2 ★",
      stat2Label: "Promedio combinado",
      stat3: "2",
      stat3Label: "Sedes en BA",
    },
    about: {
      kicker: "Nuestra historia",
      title: "Tradición porteña, porciones que se comparten",
      paragraph1:
        "En Bodegón Núñez creemos que la mesa une. Desde nuestras dos sedes en Palermo y Núñez, servimos los clásicos del bodegón argentino con porciones tan abundantes que están pensadas para compartir entre amigos y familia.",
      paragraph2:
        "Las milanesas gigantes nos hicieron conocidos —tan grandes que dos personas terminan satisfechas con una sola fuente—, pero no se quedan ahí: pastas caseras, pescados frescos, postres que rinden el doble y una atención que te hace sentir como en casa.",
      handwritten: "“se te escapó la tortuga”",
      feature1: "Porciones XXL",
      feature1Desc: "Pensadas para compartir entre 2 o 3.",
      feature2: "Cocina casera",
      feature2Desc: "Recetas tradicionales del bodegón porteño.",
      feature3: "Atención cálida",
      feature3Desc: "Mozos atentos y ambiente familiar.",
    },
    gallery: {
      kicker: "Galería",
      title: "Lo que vas a vivir",
      subtitle: "Un paseo visual por la mesa, las sedes y los clásicos de la casa.",
    },
    locations: {
      kicker: "Dos sedes",
      title: "Encontranos en Buenos Aires",
      subtitle: "Mismo espíritu bodeguero, dos barrios para elegir.",
      hours: "Horarios",
      address: "Dirección",
      directions: "Cómo llegar",
      reserveHere: "Reservar por WhatsApp",
      palermo: {
        name: "Sede Palermo",
        addr: "José A. Cabrera 4667, CABA",
        hours: [
          { day: "Lunes", value: "12:00 – 15:30 · noche cerrado" },
          { day: "Mar a Jue y Dom", value: "12:00 – 15:30 · 20:00 – 00:00" },
          { day: "Vie, Sáb y feriados", value: "12:00 – 15:30 · 20:00 – 01:00" },
        ],
      },
      nunez: {
        name: "Sede Núñez",
        addr: "Arribeños 3198, CABA",
        hours: [
          { day: "Dom a Jue", value: "12:00 – 15:30 · 20:00 – 00:00" },
          { day: "Vie, Sáb y feriados", value: "12:00 – 16:00 · 20:00 – 01:00" },
        ],
      },
    },
    reviews: {
      kicker: "Opiniones",
      title: "Lo que dicen nuestros clientes",
      subtitle: "Reseñas reales de Google sobre la experiencia bodegón.",
      source: "Vía Google Maps",
    },
    contact: {
      kicker: "Reservas",
      title: "Reservá tu mesa",
      subtitle:
        "Escribinos por WhatsApp y coordinamos día, hora y sede en minutos.",
      whatsapp: "Escribinos por WhatsApp",
      callPalermo: "WhatsApp Palermo",
      callNunez: "WhatsApp Núñez",
      hint: "Recomendamos reservar con anticipación, especialmente fines de semana.",
    },
    footer: {
      tagline: "El más grande bodegón porteño · Palermo & Núñez",
      rights: "Todos los derechos reservados.",
      built: "Hecho con cariño en Buenos Aires.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      gallery: "Gallery",
      locations: "Locations",
      reviews: "Reviews",
      contact: "Contact",
      reserve: "Reserve",
    },
    hero: {
      tagline: "Buenos Aires bodegón · the porteño classic",
      title: "BODEGÓN NÚÑEZ",
      subtitle: "— THE BIGGEST ONE —",
      description:
        "Giant milanesas, generous sharing portions, and the authentic flavour of Buenos Aires cuisine.",
      cta: "Book on WhatsApp",
      ctaSecondary: "See our locations",
      stat1: "9,000+",
      stat1Label: "Google reviews",
      stat2: "4.2 ★",
      stat2Label: "Average rating",
      stat3: "2",
      stat3Label: "BA locations",
    },
    about: {
      kicker: "Our story",
      title: "Buenos Aires tradition, plates made to share",
      paragraph1:
        "At Bodegón Núñez we believe the table brings people together. From our two locations in Palermo and Núñez we serve the classics of Argentine cuisine in portions so generous they are made to be shared with friends and family.",
      paragraph2:
        "Our giant milanesas put us on the map —so big that two people leave full from a single platter—, but we don't stop there: house-made pastas, fresh fish, oversized desserts and a warm service that feels like home.",
      handwritten: "“the turtle got away”",
      feature1: "XXL portions",
      feature1Desc: "Built to share between 2 or 3.",
      feature2: "Home-style kitchen",
      feature2Desc: "Traditional porteño bodegón recipes.",
      feature3: "Warm hospitality",
      feature3Desc: "Attentive waiters, family vibe.",
    },
    gallery: {
      kicker: "Gallery",
      title: "What you'll experience",
      subtitle: "A visual tour through the table, the rooms and our house classics.",
    },
    locations: {
      kicker: "Two locations",
      title: "Find us in Buenos Aires",
      subtitle: "Same bodegón spirit, two neighbourhoods to choose from.",
      hours: "Opening hours",
      address: "Address",
      directions: "Get directions",
      reserveHere: "Book on WhatsApp",
      palermo: {
        name: "Palermo Branch",
        addr: "José A. Cabrera 4667, Buenos Aires",
        hours: [
          { day: "Monday", value: "12:00 – 3:30 PM · evening closed" },
          { day: "Tue – Thu & Sun", value: "12:00 – 3:30 PM · 8:00 PM – 12:00 AM" },
          { day: "Fri, Sat & holidays", value: "12:00 – 3:30 PM · 8:00 PM – 1:00 AM" },
        ],
      },
      nunez: {
        name: "Núñez Branch",
        addr: "Arribeños 3198, Buenos Aires",
        hours: [
          { day: "Sun – Thu", value: "12:00 – 3:30 PM · 8:00 PM – 12:00 AM" },
          { day: "Fri, Sat & holidays", value: "12:00 – 4:00 PM · 8:00 PM – 1:00 AM" },
        ],
      },
    },
    reviews: {
      kicker: "Reviews",
      title: "What our guests say",
      subtitle: "Real Google reviews about the bodegón experience.",
      source: "Via Google Maps",
    },
    contact: {
      kicker: "Reservations",
      title: "Book your table",
      subtitle:
        "Message us on WhatsApp and we'll arrange day, time and location in minutes.",
      whatsapp: "Message us on WhatsApp",
      callPalermo: "WhatsApp Palermo",
      callNunez: "WhatsApp Núñez",
      hint: "We recommend booking ahead, especially on weekends.",
    },
    footer: {
      tagline: "The biggest porteño bodegón · Palermo & Núñez",
      rights: "All rights reserved.",
      built: "Made with love in Buenos Aires.",
    },
  },
};

export const reviewsData = [
  {
    id: 1,
    name: "Pablo Cuadra",
    role: "Local Guide · 316 reviews",
    rating: 5,
    when: { es: "Hace 7 meses", en: "7 months ago" },
    text: {
      es: "Excelente bodegón en Buenos Aires, las milanesas son enormes, hasta para tres personas. La tortilla de papas española es exquisita y abundante. El ambiente es ameno y la atención muy buena. Altamente recomendable.",
      en: "Excellent bodegón in Buenos Aires, the milanesas are huge, even for three people. The Spanish potato omelette is exquisite and abundant. Lovely atmosphere and great service. Highly recommended.",
    },
  },
  {
    id: 2,
    name: "Fernando LO",
    role: "Local Guide · 164 reviews",
    rating: 4,
    when: { es: "Hace 7 meses", en: "7 months ago" },
    text: {
      es: "Muy buen bodegón de barrio, con el encanto clásico porteño y porciones realmente gigantes que hacen honor a la tradición. La atención fue muy cordial y el ambiente distendido, familiar y auténtico.",
      en: "A great neighbourhood bodegón with classic porteño charm and truly giant portions that honour tradition. Very cordial service and a relaxed, authentic family atmosphere.",
    },
  },
  {
    id: 3,
    name: "Mauri Garcia",
    role: "Local Guide · 109 reviews",
    rating: 5,
    when: { es: "Hace 5 meses", en: "5 months ago" },
    text: {
      es: "Un bodegón con buena comida, porciones abundantes y variadas. Buen precio y ambiente bastante agradable en Palermo. Las milas gigantes, buñuelos de entrada y el flan casero ¡una locura!",
      en: "A bodegón with great food, abundant and varied portions. Good prices and a lovely atmosphere in Palermo. The giant milanesas, the chard fritters and the house flan are insane!",
    },
  },
  {
    id: 4,
    name: "Burger Boy",
    role: "Local Guide · 42 reviews",
    rating: 5,
    when: { es: "Hace 2 meses", en: "2 months ago" },
    text: {
      es: "La milanesa de cuatro quesos es una bomba que rinde posta para dos personas que comen fuerte. Un bodegón cumplidor con porciones XXL, ideal para ir con un amigo y compartir.",
      en: "The four-cheese milanesa is a beast that easily feeds two big eaters. A solid bodegón with XXL portions, perfect to go with a friend and share.",
    },
  },
  {
    id: 5,
    name: "Tomás Lifona",
    role: "Local Guide · 49 reviews",
    rating: 5,
    when: { es: "Hace 7 meses", en: "7 months ago" },
    text: {
      es: "Fuimos después de correr la media maratón, con muchísimo hambre, y pedimos una súper milanesa. ¡Estaba tremenda! Porciones abundantes, perfectas para compartir entre dos.",
      en: "We came after running the half marathon, starving, and ordered a super milanesa. It was tremendous! Abundant portions, perfect to share between two.",
    },
  },
  {
    id: 6,
    name: "Pablo Stachiola",
    role: "Local Guide · 183 reviews",
    rating: 5,
    when: { es: "Hace 11 meses", en: "11 months ago" },
    text: {
      es: "Excelente lugar para comer, rico, abundante y rápido. Pedimos milanesa Gringa y matambre a la pizza, súper abundante. Cenamos los 4 y sobró. Los postres también son abundantes.",
      en: "Excellent place to eat — tasty, abundant and fast. We ordered the Gringa milanesa and matambre a la pizza, super generous. The four of us ate and there were leftovers. Desserts are huge too.",
    },
  },
  {
    id: 7,
    name: "Agustina Astorga",
    role: "4 reviews",
    rating: 5,
    when: { es: "Hace 8 meses", en: "8 months ago" },
    text: {
      es: "He ido tres veces y me gusta mucho. El ambiente es genial y los mozos también. Las milanesas son exquisitas y muy grandes. Las berenjenas a la parmesana, buenísimas como nunca había probado.",
      en: "I've been three times and I love it. The vibe is great and so are the waiters. The milanesas are delicious and huge. The eggplant parmigiana was the best I've ever tried.",
    },
  },
  {
    id: 8,
    name: "Sandra Cabrera",
    role: "Local Guide · 72 reviews",
    rating: 5,
    when: { es: "Hace 4 meses", en: "4 months ago" },
    text: {
      es: "Muy buena la comida, abundante para compartir con más de dos, muy poca espera, la atención de los mozos excelente.",
      en: "Great food, abundant enough to share between more than two, very little wait, and excellent service from the waiters.",
    },
  },
];
